import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
interface BuyButtonProps {
  className?: string;
  children?: React.ReactNode;
  onClick?: () => void;
}
export function BuyButton({
  className = '',
  children = 'QUIERO DOMINAR LA BANDA',
  onClick
}: BuyButtonProps) {
  const handleClick = (e: React.MouseEvent) => {
    if (onClick) {
      onClick();
      return;
    }
    e.preventDefault();
    const offerSection = document.getElementById('comprar');
    if (offerSection) {
      offerSection.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <motion.button whileHover={{
    scale: 1.04,
    y: -2
  }} whileTap={{
    scale: 0.97
  }} transition={{
    type: 'spring',
    stiffness: 400,
    damping: 17
  }} onClick={handleClick} className={`group relative inline-flex items-center justify-center gap-2 overflow-hidden bg-[#84cc16] text-[#14321a] font-bold py-4 px-8 rounded-2xl text-lg md:text-xl uppercase tracking-wide shadow-[0_8px_24px_-6px_rgba(132,204,22,0.6)] ring-1 ring-[#65a30d]/40 transition-shadow hover:shadow-[0_12px_32px_-4px_rgba(132,204,22,0.75)] w-full max-w-md mx-auto ${className}`} style={{
    fontFamily: 'Anton, sans-serif'
  }} data-id="element-35">
      {/* Shine sweep */}
      <span className="pointer-events-none absolute inset-0 -translate-x-full bg-gradient-to-r from-transparent via-white/40 to-transparent group-hover:translate-x-full transition-transform duration-700 ease-out" data-id="element-36" />
      <span className="relative z-10" data-id="element-37">{children}</span>
      <ArrowRight className="relative z-10 w-5 h-5 transition-transform group-hover:translate-x-1" data-id="element-38" />
    </motion.button>;
}